/**
 * IDENTITY_FORM -
 * SMS_CONFIRMATION -
 */
export enum EIdentityClientStep {
  IDENTITY_FORM = 'IDENTITY_FORM',
  SMS_CONFIRMATION = 'SMS_CONFIRMATION',
}
